import { isDefined } from "@banjoanton/utils";
import type { EvaluatorEngine } from "../../../engines/evaluator-engine";
import type { Move } from "../../../models/move-model";
import type { MoveAnnotation } from "../models/move-annotation";
import { UndefendedPieceAnnotationService } from "./annotations/undefended-piece-annotation-service";
import { ForkAnnotationService } from "./annotations/fork-annotation-service";
import { SacrificeAnnotationService } from "./annotations/sacrifice-annotation-service";

type CalculateAnnotationProps = {
    evaluator: EvaluatorEngine;
    move: Move | undefined; // is undefined for first move
    previousMoves: Move[] | undefined; // is undefined for first and second move
};

export type CalculateProps = CalculateAnnotationProps & {
    move: Move;
};

export type CalculateAnnotationFunction = (
    props: CalculateProps
) => Promise<MoveAnnotation[]>;

const calculateAnnotations = async (
    props: CalculateAnnotationProps
): Promise<MoveAnnotation[]> => {
    const { move } = props;
    if (!isDefined(move)) {
        return [];
    }

    const calculateFunctions: CalculateAnnotationFunction[] = [
        ForkAnnotationService.calculate,
        UndefendedPieceAnnotationService.calculate,
        SacrificeAnnotationService.calculate,
    ];

    let annotations: MoveAnnotation[] = [];
    for (const calculate of calculateFunctions) {
        const result = await calculate({ ...props, move });
        if (isDefined(result)) {
            annotations = [...annotations, ...result];
        }
    }

    return annotations;
};

export const AnnotationService = { calculateAnnotations };
